<div class="modal-wrapper">
  <div class="modal">
    <div class="modal-title">{{ header }}</div>
    <div class="modal-content">
      <div class="alert-message">{{ message }}</div>
      @if (inputs?.length) {
        <div class="alert-inputs">
          @for (input of inputs; track input; let i = $index) {
            <mat-form-field appearance="fill">
              <input
                matInput
                [type]="input.type || 'text'"
                [name]="(input.name || i) + ''"
                [placeholder]="input.placeholder || ''"
                [value]="input.value"
                [disabled]="!!input.disabled"
                [min]="input.min"
                [max]="input.max"
                (change)="onChangeInput(input, i, $event)"
              />
            </mat-form-field>
          }
        </div>
      }
    </div>
    <div class="modal-footer">
      <div class="alert-buttons">
        @for (button of buttons; track button) {
          @switch (buttonFill) {
            @case ("solid") {
              <button mat-raised-button color="primary" (click)="onClickButton(button)">
                {{ button.text }}
              </button>
            }
            @case ("outline") {
              <button mat-stroked-button color="primary" (click)="onClickButton(button)">
                {{ button.text }}
              </button>
            }
            @default {
              <button mat-button color="primary" (click)="onClickButton(button)">
                {{ button.text }}
              </button>
            }
          }
        }
      </div>
    </div>
  </div>
</div>
